
import React, { useEffect } from 'react'
import './App.css';
import { useTranslation } from 'react-i18next';
import ComingSoon from './components/soonPage/soon';
import MobileComingSoon from './components/soonPage/mobileSoon';
import headerLogo from "./images/headerLogo.png"

const App = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const changeLanguage = () => {
      let language = currentUrl.includes("sk.tastescanvote.com") ? "sk" : currentUrl.includes("hu.tastescanvote.com") ? "hu" : currentUrl.includes("cz.tastescanvote.com") ? "cz" : ""
      i18n.changeLanguage(language)
    }

    return changeLanguage()

  }, [1])


  let currentUrl = window.location.origin

  return (
    <div className="App">

      <img src={headerLogo} alt="Lay's logo" />

      { (currentUrl.includes("sk.tastescanvote") || currentUrl.includes("cz.tastescanvote") || currentUrl.includes("hu.tastescanvote") ) &&
        <>
          <ComingSoon currentUrl={currentUrl} />
          <MobileComingSoon currentUrl={currentUrl} />
        </>}

    </div>
  );
}

export default App;
